import { getAdvertisingApiCsrfToken } from 'src/commons/apis';
import { setAdvertisingApiCsrfToken } from './slice';

export const fetchAdvertisingApiCsrfToken = () => async (dispatch) => {
  const csrfToken = await getAdvertisingApiCsrfToken();
  dispatch(setAdvertisingApiCsrfToken({ csrfToken }));
};
